import { useMemo, useState } from 'react';

export const useCounter: () => [number, () => void] = () => {
    const [count, setCount] = useState<number>(0);
    return useMemo(() => [count, () => setCount((currentCount) => currentCount + 1)] as [number, () => void], [count, setCount]);
};
